import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-right-line.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-right.svg'


const _hoisted_1 = { class: "w-1/2 flex flex-row justify-start items-center gap-6" }
const _hoisted_2 = { class: "flex flex-col space-y-1" }
const _hoisted_3 = { class: "flex flex-col text-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-full max-w-none",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "flex flex-col space-y-1" }
const _hoisted_6 = { class: "w-1/4 flex justify-center items-center" }
const _hoisted_7 = { class: "flex flex-col space-y-1" }
const _hoisted_8 = {
  key: 0,
  class: "w-1/6"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold font-montserrat text-gray-lp-300" }, " Terbang Dalam ", -1)
const _hoisted_10 = { class: "bg-yellow-lp-200 px-2 rounded-xl text-14px text-yellow-lp-100 mt-2 inline-flex" }
const _hoisted_11 = { class: "pr-1" }
const _hoisted_12 = { class: "w-1/2 flex flex-row justify-start items-center gap-6" }
const _hoisted_13 = { class: "flex flex-col space-y-1" }
const _hoisted_14 = { class: "font-semibold text-20px text-black-lp-300" }
const _hoisted_15 = { class: "text-12px xxl:text-14px ellipsis-2 text-gray-lp-600" }
const _hoisted_16 = { class: "flex flex-col text-center" }
const _hoisted_17 = { class: "text-12px text-gray-lp-600" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-full max-w-none",
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "flex flex-col space-y-1" }
const _hoisted_21 = { class: "flex flex-row items-center" }
const _hoisted_22 = { class: "font-semibold text-20px text-black-lp-300" }
const _hoisted_23 = {
  key: 0,
  class: "flex justify-center items-center ml-2"
}
const _hoisted_24 = { class: "text-center text-10px text-white py-1 px-2 bg-red-lp-100 rounded-md" }
const _hoisted_25 = { class: "text-12px xxl:text-14px ellipsis-2 text-gray-lp-600" }
const _hoisted_26 = { class: "w-1/4 flex justify-center items-center" }
const _hoisted_27 = { class: "flex flex-col space-y-1" }
const _hoisted_28 = { class: "font-semibold text-20px text-black-lp-300" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-600" }, " No. Penerbangan ", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-6 max-w-none",
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `${_ctx.width} px-6 py-5 gap-6 items-center justify-between flex flex-row cursor-pointer border border-gray-lp-400 shadow rounded-lg`
    ,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChoosePlane && _ctx.onChoosePlane(...args)))
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Skeleton, {
                width: "7rem",
                height: "2.4rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "12rem",
                height: "1.5rem"
              })
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_Skeleton, {
                width: "10rem",
                height: "1.2rem"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Skeleton, {
                width: "7rem",
                height: "2.4rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "12rem",
                height: "1.5rem"
              })
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Skeleton, {
                width: "7rem",
                height: "2.4rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "12rem",
                height: "1.5rem"
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.data && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.formatCalculateDiffTime)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_Icons, {
                      name: "clock-cargo",
                      class: "w-4"
                    })
                  ]),
                  _createVNode("div", null, _toDisplayString(_ctx.formatCalculateDiffTime), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.departureDateTime), 1),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.departureAirport.airportCode) + " - " + _toDisplayString(_ctx.firstCapitalize(_ctx.departureAirport.cityName)), 1)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                (_ctx.differenceDate.hours)
                  ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.differenceDate.hours) + " Jam ", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.differenceDate.minutes) + " Menit ", 1)
              ]),
              _hoisted_19
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.arrivalDateTime), 1),
                (_ctx.differenceDate.date)
                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, " +" + _toDisplayString(_ctx.differenceDate.date) + " Hari ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.arrivalAirport.airportCode) + " - " + _toDisplayString(_ctx.firstCapitalize(_ctx.arrivalAirport.cityName)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.detailData.FlightNo), 1),
              _hoisted_29
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_30
  ], 2))
}